import { Button } from "ui/components/button";
import  Icon  from "../icon";
import { MENU } from "icons";
import { DropdownMenuTrigger } from "ui/components/dropdown-menu";

export default function DropdownMenuButton() {
  return (
    <DropdownMenuTrigger asChild>
      <Button size="icon" variant="outline">
        <Icon icon={MENU} className="size-4" />
      </Button>
    </DropdownMenuTrigger>
  );
}
